<div [formGroup]="formGroup">
  <mat-card class="paper-card">
    <mat-card-header>
      <mat-card-subtitle *ngIf="clientNumber == 0">
        <div class="font-weight-bold">
          Agregar Cliente Principal
        </div>
      </mat-card-subtitle>
      <mat-card-subtitle *ngIf="clientNumber != 0">
        <div class="font-weight-bold">
          Agregar Cliente Extra
        </div>
        <div class="btnClose">
          <mat-icon class="close-button" matTooltip="eliminar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="DeleteCustomer()"></mat-icon>
        </div>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="input-row">
        <div class="col-2 custom-input-container">
          <mat-form-field>
            <mat-label>Cliente *</mat-label>
            <mat-select formControlName="client" (selectionChange)="onChangeClient()" placeholder="Seleccionar *" required>
              <mat-option *ngFor="let client of customers" [value]="client">{{ client }}</mat-option>
          </mat-select>
          </mat-form-field>
          <span>{{ getError("client") }}</span>
        </div>
        <div class="col-3 custom-input-container">
          <div class="" style="display: flex; flex-direction: column; width: 70%;">
            <mat-form-field>
              <mat-label>Rol *</mat-label>
              <mat-select formControlName="rol" (selectionChange)="onChangeRole($event)" required>
                <mat-option *ngFor="let rol of roles" [value]="rol">{{ rol }}</mat-option>
              </mat-select>
            </mat-form-field>
            <span>{{ getError("rol") }}</span>
          </div>
          

          <div class="role-actions" style="width: 30%;">
            <button 
              mat-icon-button 
              color="primary" 
              matTooltip="Agregar nuevo rol" 
              matTooltipPosition="above"
              (click)="goToAddRole()"
              type="button">
              <mat-icon>add</mat-icon>
            </button>
            
            <button 
              mat-icon-button 
              color="accent" 
              matTooltip="Recargar roles" 
              matTooltipPosition="above"
              (click)="reloadRoles()"
              type="button">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
        <div class="col-2 custom-input-container">
          <mat-form-field>
            <mat-label>Grupos </mat-label>
            <mat-select formControlName="groups" placeholder="Seleccionar grupos" value="" (selectionChange)="onChangeGroupOptions($event)" multiple>
              <mat-option class="hide-checkbox" value="" (click)="resetGroups()">Todos</mat-option>
              <mat-option *ngFor="let group of groups" [value]="group">{{ group }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-2 custom-input-container">
          <mat-form-field>
            <mat-label>Sub Grupos </mat-label>
            <mat-select formControlName="subGroups" placeholder="Seleccionar sub grupos" value="Vacio" (selectionChange)="onChangeSubGroupOptions($event)" multiple>
              <mat-option class="hide-checkbox" value="Vacio" (click)="noSubGroups()">--- Seleccionar ---</mat-option>
              <mat-option class="hide-checkbox" value="" (click)="allSubGroups()">Todos los actuales</mat-option>
              <mat-option *ngFor="let subGroup of subGroups" [value]="subGroup">{{ subGroup }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
  
      <!-- será para los identificadores -->
      <div class="multiple-client-container" *ngIf="isDirectAssign">
        <mat-accordion multi hideToggle class="permission-expand">
          <mat-expansion-panel [expanded]="isDirectAssign" >
  
            <!-- cabecera del panel -->
            <mat-expansion-panel-header >
              <mat-panel-title>
                <div class="font-weight-bold col-3 expannsion-panel-title">
                  Asignación Directa de Activos
                </div> 
                <div class="color-gray col-6 mobile-display-none">
                  *Sólo se abre si el rol permite asignación directa 
                </div> 
                <div class="color-gray col-3 mobile-display-none">
                  *Debe haber un cliente seleccionado
                </div> 
              </mat-panel-title>
              <div class="panel-title">
                <mat-slide-toggle style="pointer-events: none;" [ngModel]="isDirectAssign" [ngModelOptions]="{standalone: true}"></mat-slide-toggle>
              </div>
            </mat-expansion-panel-header>
  
            <!-- Cuerpo del panel -->
            <div class="selected-list-container">
              <div class="input-row" *ngIf="isDirectAssign">
                <div class="col-12 custom-input-container" style="overflow: auto; display: flex;">
                  
                    <!-- <mat-label>Clientes extras </mat-label> -->
                   <app-admin-vin-control class="vin-control" [clientNumber]="clientNumber" [client]="this.formGroup.controls['client'].value" [IdentifierListInput]="_vinIdentifiers" [filtersList]="filtersList" (IdentifierList)="updateIdentifiers($event)"></app-admin-vin-control>
                </div>
              </div>
            </div>
  
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </mat-card-content>
  </mat-card>
</div>